
  document.addEventListener("DOMContentLoaded", function() {
    const modal = document.getElementById("customModal");
    const btn = document.getElementById("openModalBtn");
    const closeSpan = document.querySelector(".close-modal");

    if (btn && modal) {
      // Open modal
      btn.addEventListener("click", function(e) {
        e.preventDefault(); // Prevents page jump
        modal.style.display = "block";
      });

      // Close via 'X'
      if (closeSpan) {
        closeSpan.onclick = () => modal.style.display = "none";
      }

      // Close by clicking outside
      window.onclick = (event) => {
        if (event.target == modal) modal.style.display = "none";
      }
    } else {
      console.error("Modal elements not found. Check your IDs!");
    }
  });

